(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tr", [], factory);
	else if(typeof exports === 'object')
		exports["tr"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["tr"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 